import { Skeleton, Typography } from '@mui/material';
import React from 'react';
import styles from './DataUsage.module.scss';

interface DataUsageProps {
  numberOfRecords: {
    user: React.ReactNode;
    org: React.ReactNode;
  };
  dataVolume: {
    user: React.ReactNode;
    org: React.ReactNode;
  };
  isOrgView: boolean;
  isLoading: boolean;
}

const MetricCard = ({
  label,
  isOrgView,
  isLoading,
  userValue,
  orgValue,
}: {
  label: string;
  isOrgView: boolean;
  isLoading: boolean;
  userValue: React.ReactNode;
  orgValue: React.ReactNode;
}) => (
  <div className={styles.card}>
    <Typography variant="bodySmall" className={styles.cardLabel}>
      {label}
    </Typography>
    {isOrgView ? (
      isLoading ? (
        <div className={styles.adminColumns}>
          <Skeleton animation="wave" variant="rounded" width={60} height={32} />
          <Skeleton animation="wave" variant="rounded" width={60} height={32} />
        </div>
      ) : (
        <div className={styles.adminColumns}>
          <div className={styles.adminColumn}>
            <Typography variant="bodySmall" className={styles.adminColumnLabel}>
              Yours
            </Typography>
            <Typography variant="h2" className={styles.cardValue}>
              {userValue}
            </Typography>
          </div>
          <div className={styles.adminColumn}>
            <Typography variant="bodySmall" className={styles.adminColumnLabel}>
              Org
            </Typography>
            <Typography variant="h2" className={styles.cardValue}>
              {orgValue}
            </Typography>
          </div>
        </div>
      )
    ) : isLoading ? (
      <div className={styles.memberValue}>
        <Skeleton animation="wave" variant="rounded" width={80} height={32} />
        <Skeleton animation="wave" variant="rounded" width={120} height={16} />
      </div>
    ) : (
      <div className={styles.memberValue}>
        <Typography variant="h2" className={styles.cardValue}>
          {userValue}
        </Typography>
        <Typography variant="bodySmall" className={styles.cardSubtitle}>
          Your usage this period
        </Typography>
      </div>
    )}
  </div>
);

export const DataUsage = ({
  numberOfRecords,
  dataVolume,
  isOrgView,
  isLoading,
}: DataUsageProps) => (
  <div className={styles.cards}>
    <MetricCard
      label="Number of Records"
      isOrgView={isOrgView}
      isLoading={isLoading}
      userValue={numberOfRecords.user}
      orgValue={numberOfRecords.org}
    />
    <MetricCard
      label="Data Volume"
      isOrgView={isOrgView}
      isLoading={isLoading}
      userValue={dataVolume.user}
      orgValue={dataVolume.org}
    />
  </div>
);
